import { render, staticRenderFns } from "./CellRendererCompanyStatus.vue?vue&type=template&id=9c6c6f5a&scoped=true&"
import script from "./CellRendererCompanyStatus.vue?vue&type=script&lang=js&"
export * from "./CellRendererCompanyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6c6f5a",
  null
  
)

export default component.exports